import { render, staticRenderFns } from "./GeoStats.vue?vue&type=template&id=7bf4ba30&scoped=true&"
import script from "./GeoStats.vue?vue&type=script&lang=js&"
export * from "./GeoStats.vue?vue&type=script&lang=js&"
import style0 from "./GeoStats.vue?vue&type=style&index=0&id=7bf4ba30&prod&lang=scss&"
import style1 from "./GeoStats.vue?vue&type=style&index=1&id=7bf4ba30&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf4ba30",
  null
  
)

export default component.exports